import { request } from './request'
import type { RoadmapComment, RoadmapPost } from './types'

export type PostDetail = {
  post: RoadmapPost
  comments: RoadmapComment[]
}

export type FetchPostDetailArgs = {
  postId: string
}

export const fetchPostDetail = async ({
  postId,
}: FetchPostDetailArgs): Promise<PostDetail> =>
  request<PostDetail>({ path: `/api/posts/${postId}` })
